var _rect, _circle, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckboxbase(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.999349,
    y: 0.666341,
    width: 12.6667,
    height: 12.6667,
    rx: 6.33333,
    fill: "#EDFCFE"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.33268,
    cy: 6.99967,
    r: 2.66667,
    fill: "#0FBBE6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.999349,
    y: 0.666341,
    width: 12.6667,
    height: 12.6667,
    rx: 6.33333,
    stroke: "#0FBBE6",
    strokeWidth: 0.666667
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxbase);
export default __webpack_public_path__ + "static/media/_Checkbox base.4c705e377a6d53c206515d546953519c.svg";
export { ForwardRef as ReactComponent };